<script>
export default {
    props: {
        layout: {
            type: Object,
            default: function() {
                return {
                    label: 6,
                    wrapper: 16
                };
            }
        },
        information: {
            type: String,
            default: ""
        }
    },
    created() {
        if (this.editing) {
            this.preload = true;
            this.getItem();
        }
    },
    computed: {
        editing() {
            return this.information !== "";
        }
    },
    data() {
        return {
            formLayout: 'horizontal',
            form: this.$form.createForm(this),
            preload: false,
            processing: false,
            item: {},
            content: ''
        };
    },
    methods: {
        getItem() {
            this.$http
                .get(
                    this.routeUri("api.information.show", {
                        information: this.information
                    })
                )
                .then(res => (this.item = res.data))
                .finally(() => (this.preload = false));
        },
        handleSubmit(e) {
            e.preventDefault(e);

            this.form.validateFields((err, formData) => {
                if (!err) {
                    this.processing = true;

                    let promise;

                    if (this.editing) {
                        promise = this.$http.put(
                            this.routeUri("api.information.update", {
                                information: this.information
                            }),
                            formData
                        );
                    } else {
                        promise = this.$http.post(
                            this.routeUri("api.information.store"),
                            formData
                        );
                    }

                    promise
                        .then(response =>
                            this.handleSuccessResponse(response.data)
                        )
                        .catch(error =>
                            this.handleResponseError(error.response.data)
                        )
                        .finally(() => (this.processing = false));

                }
            });
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });
            setTimeout(() => this.$emit("handleClose", true), 2000);
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        handleClose() {
            this.$emit("handleClose", false);
        },
    },
    watch: {
        item: function(value) {
            this.form.getFieldDecorator("title", { initialValue: value.title });
            this.form.getFieldDecorator("description", { initialValue: value.description });
            this.form.getFieldDecorator("is_dashboard", {
                initialValue: value.is_dashboard
            });
            this.form.getFieldDecorator("is_active", {
                initialValue: value.is_active == true ? true : false
            });
        }
    }
};
</script>

<template>
    <a-card type="inner" size="small">
        <a-skeleton :loading="preload" active>
            <a-form :form="form" :layout="formLayout" @submit="handleSubmit">
                <a-divider dashed orientation="left">Kategori Informasi</a-divider>
                <a-form-item label="Judul">
                    <a-input
                        placeholder="Judul"
                        v-decorator="[
                            'title',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Field ini wajib diisi'
                                    }
                                ]
                            }
                        ]"
                    >
                    </a-input>
                </a-form-item>

                <a-form-item label="Description">
                    <a-textarea
                        placeholder="Deskripsi"
                        :rows="4"
                        v-decorator="[
                            'description',
                            {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Field ini wajib diisi'
                                    }
                                ]
                            }
                        ]"
                    />
                </a-form-item>

                <a-form-model-item label="Status">
                    <a-switch label="Status" v-decorator="[
                            'is_active',
                            {
                                valuePropName: 'checked'
                            }
                        ]" />
                </a-form-model-item>

                <a-form-model-item label="Dashboard">
                    <a-switch
                        label="Dashboard" v-decorator="[
                            'is_dashboard',
                            {
                                valuePropName: 'checked'
                            }
                        ]" />
                </a-form-model-item>

                <a-form-item>
                    <a-row type="flex" justify="center" align="top">
                        <a-col>
                            <a-space>
                                <a-button
                                    type="primary"
                                    html-type="submit"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Submit</a-button>
                                <a-button
                                    @click="handleClose"
                                    :loading="processing"
                                    :disabled="processing"
                                    >Tutup</a-button>
                            </a-space>
                        </a-col>
                    </a-row>
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-card>
</template>
